<template>
  <header>
    <section class="bg-color-theme4">
      <div
        v-if="content && content.settings && content.settings.site"
        class="border-bottom"
      >
        <div class="d-flex align-items-center container flex-wrap">
          <span
            class="d-inline-block font-s-12 p-2 border-right text-color-black"
            >{{ content.settings.site.mobile }}</span
          >
          <span
            class="d-inline-block font-s-12 p-2 border-right border-left text-color-black"
            >{{ content.settings.site.email }}
          </span>
          <div class="flex-grow-1"></div>
          <ul class="d-flex align-items-center m-0">
            <li>
              <a
                class="d-inline-block p-2 border-right border-left"
                :href="content.settings.social.instagram ?? ''"
                ><HeaderInstagram
              /></a>
            </li>
            <li>
              <a
                class="d-inline-block p-2 border-left"
                :href="content.settings.social.whatsapp ?? ''"
                ><HeaderWhatsapp
              /></a>
            </li>
            <li>
              <a
                class="d-inline-block p-2 b border-left"
                :href="content.settings.social.telegram ?? ''"
                ><HeaderTelegram
              /></a>
            </li>
          </ul>
        </div>
      </div>
      <div class="border-bottom">
        <div
          class="container d-flex align-items-center justify-content-between gap-10 py-3"
        >
          <AtlasLogo class="logo-grow" />
          <Nav></Nav>
          <CartButton />
          <div>
            <button
              v-if="!isLogin"
              type="button"
              class="d-none d-md-block custom-btn"
              data-toggle="modal"
              data-target="#loginModal"
            >
              ورود / عضویت
            </button>
            <button
              data-toggle="modal"
              data-target="#loginModal"
              class="d-block d-md-none bg-none"
              type="button"
            >
              <UserIcon />
            </button>

            <template v-if="isLogin">
              <LoginUser />
            </template>
          </div>
          <NavButton @click="allCategoriesClose()" />
        </div>
      </div>
    </section>
    <RespLoginModal></RespLoginModal>
    <CartLists></CartLists>
    <RespMenu ref="respMenu"></RespMenu>
  </header>
</template>

<script>
import AtlasLogo from "@/parts/Front/components/AtlasLogo";
import Nav from "@/parts/Front/components/Nav";
import RespMenu from "@/parts/Front/components/RespMenu";
import LoginUser from "@/parts/Front/components/LoginUser";
import RespLoginModal from "@/parts/Front/components/RespLoginModal";
import CartLists from "@/parts/Front/components/CartLists";
import CartButton from "@/parts/Front/components/cart/CartButton";
import SearchButton from "../header/SearchButton";
import NavButton from "@/parts/Front/components/shared/NavButton";
import { openSearch } from "../../../../libraries/functions";
import HeaderInstagram from "@/parts/Front/components/Icon/HeaderInstagram.vue";
import HeaderWhatsapp from "@/parts/Front/components/Icon/HeaderWhatsapp.vue";
import HeaderTelegram from "@/parts/Front/components/Icon/HeaderTelegram.vue";
import UserIcon from "@/parts/Front/components/Icon/UserIcon.vue";
export default {
  name: "Header",
  components: {
    NavButton,
    SearchButton,
    AtlasLogo,
    Nav,
    LoginUser,
    RespMenu,
    RespLoginModal,
    CartLists,
    CartButton,
    HeaderInstagram,
    HeaderWhatsapp,
    HeaderTelegram,
    UserIcon,
  },
  inject: ["mediaQueries"],
  methods: {
    allCategoriesClose() {
      this.$refs.respMenu.allCategoriesToggle();
    },
    signout() {
      window
        .swal({
          title: "آیا میخواهید خارج شوید؟",
          icon: "warning",
          showCancelButton: true,
          showConfirmButton: true,
          dangerMode: true,
          buttons: ["خیر", "بله خارج شو"],
        })
        .then((willDelete) => {
          if (willDelete) {
            this.disabledlLogout = true;
            this.$axios.post("/customer/logout").then((res) => {
              this.disabledlLogout = false;
              this.showOptions = false;
              // پاک کردن اطلاعات مربوط به کاربر از کوکی و ویو ایکس
              delete this.$axios.defaults.headers.common["Authorization"];
              this.$root.deleteCookie("Authorization");
              this.$store.commit("front/setLoginStatus", false);
            });
          }
        });
    },
    showCloseSearchBox() {
      openSearch();
    },
  },
  mounted() {
    if (this.isLogin) {
      this.$store.dispatch("front/getNotficationsFromServer");
    }
  },
  computed: {
    // چک کردن لاگین بودن کاربر با استفاده از ویو ایکس در سند یوزر
    isLogin() {
      return this.$store.getters["front/getLoginStatus"];
    },
    content() {
      return this.$store.getters["front/getHomeData"];
    },
  },
  data() {
    return {
      disabledlLogout: false,
    };
  },
};
</script>

<style scoped>
@media screen and (max-width: 992px) {
  .logo-grow {
    flex-grow: 1;
  }
}
</style>
